import Grid from '@material-ui/core/Grid'
import Input from 'Components/Input'
import Title from 'Components/Title'
import Upload from 'Components/Upload'
import React from 'react'


export default React.memo(props => <Title inline={props.inline} style={{padding: '5px 0'}} title={props.title} buttons={!props.disabled &&<button type="button" onClick={props.onClickSaisieLibreMultipleBool}
                                                       disabled={props.disabled || false}
                                                       className="text-success ei-commun_ajouter"
                                                       style={{display: 'inline-block', marginLeft: 5}}/>}>

        {
          (props.data !== undefined ? props.data : []).map((data, index) => (

            <Grid key={index} container style={{margin: 0, padding: 0}} spacing={0} justify={'center'}
                  alignItems={'center'}>
              {props.client_id && <Grid item style={{margin: 0, padding: 0}}>
                <Upload disabled={props.disabled || false} media_id={data.valeur_entier} link={data.media_lien} client_id={props.client_id} onChange={(r) => props.onChangeUploadSaisieLibreMultipleUpload(index, r.id, r.lien)} />
              </Grid> }
              <Grid item xs style={{margin: 0, padding: 0}}>
                <Input style={props.style}
                  onChange={(e) => props.onChangeSaisieLibeMultipleBool(e, index)}
                  name={'text'}
                  disabled={props.disabled || false}
                  value={data.text !== undefined ? data.text : ""}
                />
              </Grid>
              <Grid item>
                <button type="button" onClick={() => props.onClickRemoveSaisieLibreMultipleBool(index)}
                        className="text-danger ei-commun_enlever"
                        disabled={props.disabled || false}/>
              </Grid>
            </Grid>
          ))
        }
      </Title>)


// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/SaisieLibreMultipleDocument.js